import { AccountModel, IAccount } from "@core/models";

export class AccountDTO extends AccountModel {
  prepareUpdateData() {
    return {
      telephone: this[IAccount.phone],
      prenom: this[IAccount.firstname],
      nom: this[IAccount.lastname],
    };
  }
}
